module.exports = __webpack_public_path__ + "img/vk.d61bfdd7.svg";